var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.backgroundColor, { 'relative z-[61]': _vm.$storyblok.isEditing }]},[_vm._l((_vm.sections),function(section){return [_c('Widget',{key:section._uid,attrs:{"data":section}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }